const PDP_USP_MESSAGE = {
  PDP__USP__POMELO_PICKUP: 'Tap.Try.Buy',
  PDP__USP__POMELO_PICKUP_DESC: 'Try first, pay later upto 15 items',
  PDP__USP__POMELO_PICKUP_CTA: 'How it works?',
  PDP_USP_HOOLAH: 'Get what you love and split the payment',
  PDP_USP_HOOLAH_DESC: '0% installment payment for 3 months',
  PDP_USP_HOOLAH_CTA: 'Learn more',
  PDP__USP__FREE_SHIPPING: 'Free shipping over 790 THB',
  PDP__USP__FREE_SHIPPING_DESCRIPTION: 'Get the order fast at your door',
  PDP__USP__FREE_RETURN: 'Free return within 30 days',
  PDP_USP_NO_RETURN_TITLE: 'Return and exchange are not supported',
  PDP_USP_NO_RETURN_SUBTITLE: 'Certain items can’t be returned for refunds',
  PDP_USP_NO_RETURN_CTA: 'LEARN MORE',
  PDP_USP_ITALIST_LUXURY_GOODS_TITLE: 'Verified luxury goods',
  PDP_USP_ITALIST_LUXURY_GOODS_SUBTITLE:
    'A 50-point quality and service checklist is conducted before items are added to our platform.',
  // PDP_USP_ITALIST_LUXURY_GOODS_CTA: 'LEARN MORE',
  PDP_USP_ITALIST_FREE_SHIPPING_TITLE: 'Free shipping for all Italist items',
  PDP_USP_ITALIST_FREE_SHIPPING_SUBTITLE: `You won't have to pay any import or customs fees!`,
  PDP_USP_ITALIST_FULFILLS_TITLE: 'Fulfills from the EU',
  PDP_USP_ITALIST_FULFILLS_SUBTITLE:
    'Delivery time will be approximately 2 weeks.',
  PDP_USP_ITALIST_FULFILLS_CTA: 'LEARN MORE',
}
const GUEST = {
  PDP_USP_LOYALTY_GUEST: 'Sign up and get Pomelo Perks benefits',
  PDP_USP_LOYALTY_GUEST_DESC:
    'Up to 5% order value back for loyalty members on app',
  joinCta: true,
}
const NON_MEMBER = {
  PDP_USP_LOYALTY_NON_MEMBER: 'Join Pomelo Perks for more benefits',
  PDP_USP_LOYALTY_NON_MEMBER_DESC: 'Earn 5% Cashback on all orders',
  joinCta: true,
}
const MEMBER = {
  PDP_USP_LOYALTY_MEMBER: 'Enjoy getting 5% back to your order',
  PDP_USP_LOYALTY_MEMBER_DESC: 'Earn 5% Cashback on all orders',
}
const JOIN_CTA = { PDP_USP_LOYALTY_CTA: 'JOIN NOW' }
const SIGN_UP_CTA = { PDP_USP_LOYALTY_CTA_NOT_LOGIN: 'SIGN UP NOW' }

export { PDP_USP_MESSAGE, GUEST, MEMBER, NON_MEMBER, JOIN_CTA, SIGN_UP_CTA }
